import { defineMessages } from "@/i18n";
import en from "./en";

export const cursorsMessages = defineMessages("cursors", en);
